// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productCarouselProductStyles } from "@sc/Overrides/Components/ProductCarouselProduct";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductStyles.productGridContainer = {
    container: {
        css: css`
            max-width: 319px;
            padding: 13px;
            border: 1px solid ${color("common.border")};
            border-radius: 4px;
        `,
    },
};
productCarouselProductStyles.productBrandWrapper = {
    css: css`
        display: inline-flex;
    `,
};

productCarouselProductStyles.infoSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productCarouselProductStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            position: relative;
            height: 293px;
            width: 100%;
            margin-bottom: 8px;
            ${xScreen("lte", "md")} {
                height: initial;
            }
        `,
    },
    img: {
        width: 293,
        height: 293,
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
            object-fit: contain;
        `,
    },
};
productCarouselProductStyles.productDescriptionStyles = {
    productDetailDescription: {
        css: css`
            min-height: 42px;
            ${xScreen("lte", 767)} {
                min-height: auto;
            }
        `,
    },
    productDetailLink: {
        css: css`
            min-height: 42px;
            ${xScreen("lte", 767)} {
                min-height: auto;
            }
        `,
    },
};

productCarouselProductStyles.productPriceWrapper = {};
productCarouselProductStyles.priceAndActionsWrapper = {
    css: css`
        height: 100%;
    `,
};

productCarouselProductStyles.badgeText = {
    weight: "bold",
    size: 10,
    lineHeight: "16px",
    transform: "uppercase",
    css: css`
        width: 100%;
        ${wrapInContainerStyles}
    `,
};

productCarouselProductStyles.productPartNumbersStyles = {};
productCarouselProductStyles.productAddToListLinkStyles = {};
